import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0cfbdf95"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox"
};
const _hoisted_2 = {
  class: "page-body"
};
import Head from '@/components/Head.vue';
import { getUrlParams } from '@/plugins/utils';
import { Empty } from 'zhs-components';
import GroupHeader from './components/groupHeader.vue';
import DetailIntro from './components/detailIntro.vue';
import Footer from '@/components/Footer.vue';
import TeachCenterHead from '@/pages/teachCenter/components/Header.vue';
export default {
  setup(__props) {
    const menuInfo = ref({});
    const $http = inject('$http');
    const groupSiteId = getUrlParams('groupSiteId'); // 来源

    const source = getUrlParams('source');
    const groupDetail = ref(null);

    const getGroupDetail = async () => {
      const res = await $http.getCourseGroupDetail({
        site_id: groupSiteId
      });
      groupDetail.value = res;
      console.log('课程组详情', res);
    };

    getGroupDetail();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Head, {
        menuCode: "54001",
        menuInfo: menuInfo.value,
        "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => menuInfo.value = $event)
      }, null, 8, ["menuInfo"]), groupDetail.value ? (_openBlock(), _createBlock(GroupHeader, {
        key: 0,
        menu: menuInfo.value,
        groupInfo: groupDetail.value
      }, null, 8, ["menu", "groupInfo"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [groupDetail.value ? (_openBlock(), _createBlock(DetailIntro, {
        key: 0,
        menu: menuInfo.value,
        groupBasicInfo: groupDetail.value
      }, null, 8, ["menu", "groupBasicInfo"])) : _createCommentVNode("", true)]), _createVNode(Footer)]);
    };
  }

};